import { render, staticRenderFns } from "./MdssOpenApi.vue?vue&type=template&id=86e17056&scoped=true"
import script from "./MdssOpenApi.vue?vue&type=script&lang=js"
export * from "./MdssOpenApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e17056",
  null
  
)

export default component.exports